<template>
  <main role="Profile">
    <div class="card-on-card">
      <div class="card-header" style="background-color: transparent">
        <h4 class="card-title mb-3 mt-3">Profile Mall</h4>
        <ul
          class="nav nav-pills nav-pills-primary"
          id="nav-list"
          role="tablist"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              href="#identitas"
              role="tab"
              aria-controls="identitas"
              aria-selected="true"
              >Identitas</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#legalitas"
              role="tab"
              aria-controls="legalitas"
              aria-selected="false"
              >Legalitas</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#alamat"
              role="tab"
              aria-controls="alamat"
              aria-selected="false"
              >Alamat</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#rekening"
              role="tab"
              aria-controls="rekening"
              aria-selected="false"
              >Rekening Bank</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#gambar"
              role="tab"
              aria-controls="gambar"
              aria-selected="false"
              >Gambar</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#user"
              role="tab"
              aria-controls="user"
              aria-selected="false"
              >User</a
            >
          </li>
        </ul>
      </div>

      <div class="card-body">
        <div class="tab-content mt-3">
          <Identitas :editIdentity="editIdentity" :loading="loading" />
          <Legalitas :editLegality="editLegality" />
          <Alamat />
          <Rekening />
          <Gambar :editPicture="editPicture" :loading="loading" />
          <ModalUser :listUser="listUser" />
          <User :listUser="listUser" :submitNewUser="submitNewUser" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";
import $ from "jquery";
import Identitas from "./Identitas";
import Legalitas from "./Legalitas";
import Alamat from "./Alamat";
import Rekening from "./Rekening";
import Gambar from "./Gambar";
import ModalUser from "./ModalUser/ModalUser.vue";
import User from "./User";

export default {
  computed: {
    google: gmapApi,
    ...mapGetters({
      user: "user",
    }),
  },
  data() {
    return {
      listUser: [],
      name: "",
      loading: false,
    };
  },
  components: {
    Identitas,
    Legalitas,
    Alamat,
    Rekening,
    Gambar,
    ModalUser,
    User,
  },
  mounted: function() {
    $("#nav-list a").on("click", function(e) {
      e.preventDefault();
      $(this).tab("show");
    });
  },
  created() {
    this.getUser();
  },
  methods: {
    editIdentity() {
      var formdata = new FormData();
      var myHeaders = new Headers();

      myHeaders.append("Cookie", "ci_session=k4piijumodoaunrs46rav4fato0sln1v");

      formdata.append("mall_id", this.user.id);
      formdata.append("name", $("#mallName").val());
      formdata.append("jenis_usaha", $("#jenisUsaha").val());
      formdata.append("kategori_usaha", $("#businessCategory").val());
      formdata.append("jenis", $("#statusUsaha").val());
      formdata.append("npwp_id", $("#npwp").val());
      formdata.append("siup_id", $("#siup").val());
      formdata.append("ktp_id", $("#NIK").val());
      formdata.append("email", $("#email_toko").val());
      formdata.append("jabatan_pic", $("#jabatan_pic").val());
      formdata.append("nama_pic", $("#nama_pic").val());
      formdata.append("telp_pic", $("#no_telp").val());
      formdata.append("param", "identitas_mall");

      var requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let gThis = this;

      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Anda yakin ingin mengubah identitas?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          this.loading = true;
          if (result.isConfirmed) {
            fetch(
              "https://siplah.eurekabookhouse.co.id/api/backendseller/konfigurasi_api",
              requestOptions
            )
              .then((response) => {
                this.$store.dispatch("get_user");
                return response;
              })
              .then(() => {
                // this.$router.push({
                //   path: "/product",
                // });
                gThis.$swal.fire(
                  "Berhasil!",
                  "Anda berhasil mengupdate profile anda",
                  "success"
                );
              })
              .finally(() => {
                this.loading = false; // Kembalikan loading ke false setelah selesai
              });
          } else {
            this.loading = false; // Pastikan loading kembali ke false jika dibatalkan
          }
        });
    },
    editAddress() {
      var formdata = new FormData();
      var myHeaders = new Headers();

      myHeaders.append("Cookie", "ci_session=k4piijumodoaunrs46rav4fato0sln1v");

      formdata.append("mall_id", this.user.id);

      formdata.append("param", "alamat_mall");

      var requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let gThis = this;

      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Anda yakin ingin mengubah alamat?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            fetch(
              "https://siplah.eurekabookhouse.co.id/api/backendseller/konfigurasi_api",
              requestOptions
            )
              .then((response) => {
                this.$store.dispatch("get_user");
                return response;
              })
              .then(() => {
                // this.$router.push({
                //   path: "/product",
                // });
                gThis.$swal.fire(
                  "Berhasil!",
                  "Anda berhasil mengupdate profile anda",
                  "success"
                );
              });
          }
        });
    },
    editLegality(paramsType, paramsElId) {
      var formdata = new FormData();
      var myHeaders = new Headers();

      let defaultLogo = new File([null], null, {
        type: "image/jpeg",
      });

      myHeaders.append("Cookie", "ci_session=k4piijumodoaunrs46rav4fato0sln1v");

      formdata.append("param", paramsType);
      formdata.append("mall_id", this.user.id);
      formdata.append(
        "npwp",
        document.getElementById(paramsElId).files.length === 0
          ? defaultLogo
          : document.getElementById(paramsElId).files[0],
        document.getElementById(paramsElId).files.length === 0
          ? defaultLogo.name
          : document.getElementById(paramsElId).files[0].name
      );

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      // for (var pair of formdata.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }

      let gThis = this;

      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Anda yakin ingin mengubah foto legalitas?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            fetch(
              "https://siplah.eurekabookhouse.co.id/api/backendseller/konfigurasi_api",
              requestOptions
            )
              .then((response) => {
                this.$store.dispatch("get_user");
                return response;
              })
              .then(() => {
                // console.log(data);
                gThis.$swal.fire(
                  "Berhasil!",
                  "Anda berhasil mengupdate profile anda",
                  "success"
                );
              });
          }
        });
    },
    editPicture() {
      var formdata = new FormData();
      var myHeaders = new Headers();

      let defaultLogo = new File([null], null, {
        type: "image/jpeg",
      });

      myHeaders.append("Cookie", "ci_session=k4piijumodoaunrs46rav4fato0sln1v");
      formdata.append("param", "gambar_logo");

      formdata.append("mall_id", this.user.id);
      formdata.append(
        "logo_mall",
        document.getElementById("editLogo").files.length === 0
          ? defaultLogo
          : document.getElementById("editLogo").files[0],
        document.getElementById("editLogo").files.length === 0
          ? defaultLogo.name
          : document.getElementById("editLogo").files[0].name
      );

      // for (var pair of formdata.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      //   // console.log(document.getElementById("editLogo").files[0].name)
      // }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let gThis = this;

      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Anda yakin ingin mengubah photo profile?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          this.loading = true;
          if (result.isConfirmed) {
            fetch(
              "https://siplah.eurekabookhouse.co.id/api/backendseller/konfigurasi_api",
              requestOptions
            )
              .then((response) => {
                this.$store.dispatch("get_user");
                return response;
              })
              .then(() => {
                gThis.$swal.fire(
                  "Berhasil!",
                  "Anda berhasil mengupdate profile anda",
                  "success"
                );
              })
              .finally(() => {
                this.loading = false; // Kembalikan loading ke false setelah selesai
              });
          } else {
            this.loading = false; // Pastikan loading kembali ke false jika dibatalkan
          }
        });
    },
    getUser() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/api/backendseller/registration_api/list_user?mall_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.listUser = data;
        });
    },
    submitNewUser() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=cf4gbmi09o3gn4e80jnpblprq259mn3h");

      var formdata = new FormData();
      formdata.append("mall_id", this.user.id);
      formdata.append("mall", this.user.name);
      formdata.append("nama", $("#namePic").val());
      formdata.append("email", $("#emailPic").val());
      formdata.append("password", $("#passwordUser").val());
      formdata.append("phone", $("#phonePic").val());
      formdata.append("jabatan", $("#jabatanPic").val());
      formdata.append("peran", "admin");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      // fetch("https://siplah.eurekabookhouse.co.id/api/backendseller/registration_api/add_user",
      //         requestOptions)
      //     .then(response => response.text())
      //     .then(result => console.log(result))
      //     .catch(error => console.log('error', error));

      this.$swal
        .fire({
          title: "Anda yakin?",
          text: "Anda yakin ingin menambah user di toko ini?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            fetch(
              "https://siplah.eurekabookhouse.co.id/api/backendseller/registration_api/add_user",
              requestOptions
            )
              .then((response) => response.json())
              .then((data) => {
                this.getUser();
                this.$swal.fire("Sukses!", data.title, "success");
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.count-badge {
  z-index: 999999999;
  position: relative;
  top: -50px;
  right: -50px;
}
</style>
